export const quizeColumnsConfig = {
    ID:"id",
    NAME:"Quiz Name",
    QUIZEDESCRIPTIION:"Description",
    CATEGORYDATA: "Category data",
    TIMELIMIT:"TIME LIMIT",
   QUIZELINK:"QUIZE LINK",
   ACTION:"Actions",
   messages: "Are you sure you want to delete this Quize?",
  };
  